'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var pollWrapper = exports.pollWrapper = function pollWrapper(_ref) {
  var request = _ref.request,
      pollingPeriod = _ref.pollingPeriod,
      shouldStop = _ref.shouldStop;

  var canceled = false;
  var cancel = function cancel() {
    canceled = true;
  };

  var poll = function poll(resolve, reject) {
    if (canceled) {
      reject(new Error('Polling has been manually canceled'));
      return;
    }

    request().then(function (response) {
      if (shouldStop(response)) {
        resolve(response);
      } else {
        setTimeout(function () {
          poll(resolve, reject);
        }, pollingPeriod);
      }
    }).catch(function (error) {
      return reject(error);
    });
  };

  return { future: new Promise(poll), cancel: cancel };
};

exports.default = pollWrapper;